<div class="row pt-3">
    <div class="col-12 text-center" tabindex="0" [ngStyle]="{ color: text_color }" [innerHTML]="getHtml(component.primary.hero_body, vehicle)">
    </div>
  </div>
